import './promotion.scss';

import Swiper from 'swiper';
import { A11y, Navigation, Pagination, Keyboard } from 'swiper/modules';
import 'swiper/scss';
import 'swiper/scss/navigation';
import 'swiper/scss/pagination';

class Promotion {
    constructor (element) {
        this.$element = element;
        this.$slider = this.$element.querySelector('[data-promotion="slider"]');
        this.$fraction = null;
        this.$prevButton = this.$element.querySelector('.swiper-button-prev');
        this.$nextButton = this.$element.querySelector('.swiper-button-next');
        this.$pagination = this.$element.querySelector('.swiper-pagination');
        this.slider = null;
    }

    init () {
        if (this.$slider) {
            this.initSlider();
        }
    }

    initSlider () {
        this.slider = new Swiper(this.$slider, {
            modules: [A11y, Navigation, Pagination, Keyboard],
            slidesPerView: 1,
            speed: 500,
            autoHeight: true,
            indicatorsInControls: false,
            pagination: {
                el: this.$pagination,
                type: 'progressbar'
            },
            keyboard: true,
            navigation: {
                prevEl: this.$prevButton,
                nextEl: this.$nextButton
            },
            a11y: {
                prevSlideMessage: window.translations.slider.prevSlideMessage,
                nextSlideMessage: window.translations.slider.nextSlideMessage,
                paginationBulletMessage: window.translations.slider.paginationBulletMessage,
                firstSlideMessage: window.translations.slider.firstSlideMessage,
                lastSlideMessage: window.translations.slider.lastSlideMessage,
                slideLabelMessage: window.translations.slider.slideLabelMessage
            },
            on: {
                slideChange: () => {
                    this.updateFraction();
                }
            }
        });

        this.updateFraction();
    }

    updateFraction () {
        this.$fraction = this.$fraction == null ? this.$element.querySelector('.swiper-pagination-fraction') : this.$fraction;

        if (this.$fraction) {
            const current = this.slider.realIndex + 1;
            const total = this.slider.slides.length;
            this.$fraction.textContent = `${current} / ${total}`;
        }
    }
}

export { Promotion };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $promotion = $context.querySelectorAll('[data-promotion="root"]');
        for (let i = 0; i < $promotion.length; i++) {
            const $$promotion = new Promotion($promotion[i]);
            $$promotion.init($promotion[i]);
        }
    }
});
